import { useCallback, useEffect, useState } from 'react';
import { api } from '../lib/api';
import { Badge, Button, Card, EmptyState, ErrorAlert } from '../components/ui';

type Any = Record<string, any>;

export function NieboGuardAlertHistorySection() {
  const [events, setEvents] = useState<Any[]>([]);
  const [actions, setActions] = useState<Any[]>([]);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<unknown>(null);
  const load = useCallback(async () => {
    setBusy(true); setError(null);
    try { const result = await api.nieboguard.alertHistory(80); setEvents(result.events); setActions(result.actions); }
    catch (err) { setError(err); } finally { setBusy(false); }
  }, []);
  useEffect(() => { load().catch(setError); }, [load]);
  return (
    <>
      {error ? <ErrorAlert error={error} /> : null}
      <Card title="Historia zdarzeń i alertów" actions={<Button size="sm" onClick={load} disabled={busy}>{busy ? 'Odświeżam…' : 'Odśwież'}</Button>}>
        <div className="nb-list">
          {events.map((event) => (
            <div className="nb-item" key={event.id}>
              <div className="nb-item__title">{event.title}</div>
              <div className="nb-item__meta">
                <Badge tone={String(event.verification_status).toUpperCase() === 'OFFICIAL' ? 'success' : 'warning'}>{event.verification_status}</Badge>
                <span>{event.event_type}</span><span>{event.severity}</span><span>{event.event_status}</span>
                <span>{event.region ?? event.voivodeship ?? 'Polska'}</span><span>{event.updated_at}</span>
              </div>
              {event.source_url ? <div className="nb-item__meta"><a href={event.source_url} target="_blank" rel="noreferrer">{event.source_url}</a></div> : null}
            </div>
          ))}
          {events.length === 0 ? <EmptyState title="Brak historii zdarzeń" hint="Historia pojawi się po synchronizacji." /> : null}
        </div>
      </Card>
      <Card title="Ostatnie operacje live">
        <div className="nb-list">
          {actions.map((action, index) => (
            <div className="nb-item" key={`${action.created_at}-${index}`}>
              <div className="nb-item__title">{action.action}</div>
              <div className="nb-item__meta"><span>{action.actor}</span><span>{action.created_at}</span></div>
              {action.notes ? <div className="nb-stat-note">{action.notes}</div> : null}
            </div>
          ))}
          {actions.length === 0 ? <EmptyState title="Brak operacji" hint="Dziennik audytowy pojawi się po akcjach operatora." /> : null}
        </div>
      </Card>
    </>
  );
}
